import { defineStore } from 'pinia';

const initialState = {
    unreadNotifications: 0,
    openTickets: 0,
    unreadTickets: 0,
};

export const usePortalStore = defineStore('portalStore', {
    state: () => initialState,

    actions: {
        setUnread(value) {
            this.unreadNotifications = Math.max(0, Number(value) || 0);
        },

        decrementUnread(by = 1) {
            this.unreadNotifications = Math.max(0, this.unreadNotifications - by);
        },

        clearUnread() {
            this.unreadNotifications = 0;
        },

        setOpenTickets(value) {
            this.openTickets = Math.max(0, Number(value) || 0);
        },

        setUnreadTickets(value) {
            this.unreadTickets = Math.max(0, Number(value) || 0);
        },
    },
});
